import React from "react";
import styled from 'styled-components';

function HeaderSpacer() {
    const HeaderSpacer = styled.div`
    height: 140px;
    width: 100%;
    background: transparent;
    @media only screen and (max-width: 600px) {
        height: 80px;
    }
    `;
  return (
    <HeaderSpacer>
    </HeaderSpacer>
  );
}

export default HeaderSpacer;
